module.exports = __webpack_public_path__ + "images/emoji/yum.d5bf73a23a2e4487f493.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/yum.png
// module id = dQWw
// module chunks = 14